import { config } from '../../config/config';

const URL_GREET_SHOPPER: string = `${config.CHATSERVER_URL}/api/Shopper/GreetShopper`;
const URL_AUTHENTICATE_SHOPPER: string = `${config.CHATSERVER_URL}/api/Shopper`;

const requestPost = {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': config.APIMGT_KEY
    },
    body: JSON.stringify({})
};

const requestGet = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json','Ocp-Apim-Subscription-Key': config.APIMGT_KEY }
};

const greetLoggedInShopper = async (shopperId: number, widgetSessionId: string) => {
    try {
        requestPost.body = JSON.stringify({ "shopperId": shopperId, "widgetSessionId": widgetSessionId });

        const response = await fetch(URL_GREET_SHOPPER, requestPost);
        const result = await response.json();
        return result;
    } catch(error) {
        console.log(JSON.stringify(error));
        return error;
    }
    
}

export {
    greetLoggedInShopper
}
